export function getAvailabilityApiRoot(publicRoute: boolean): string {
  return `${process.env.REACT_APP_AVAILABILITY_MOCK_API === 'true'
    ? '/api'
    : process.env.REACT_APP_AVAILABILITY_API_ROOT ?? '/api'}/omni${publicRoute ? '/public' : ''}/availability/api/v1/availability`;
}
